import {Localized} from "@fluent/react";
import {Divider, FormControl, Stack} from "@mui/material";
import {makeStyles} from "@mui/styles";
import React from "react";
import type {ReactNode} from "react";

import SubmitResultCard from "./SubmitResultCard";
import ProgressButton from "../../../utils/ProgressButton";

const useStyles = makeStyles((theme) => ({
	resultInfo: {
		marginTop: theme.spacing(2),
	},
}));

type Props = {
	onSubmit?: () => void;
	submitDisabled?: boolean;
	submitHidden?: boolean;
	submitting?: boolean;

	children: ReactNode | ReactNode[];

	actions?: ReactNode;

	submitSummary?: {
		success: boolean;
		text: string;
	} | null;
};

const SubmitableResponseArea = (props: Props): JSX.Element => {
	const classes = useStyles();

	const submitVisible = props.onSubmit && !props.submitSummary?.success;

	const actionsVisible = props.actions || submitVisible;

	return (
		<FormControl fullWidth>
			{props.children}

			{props.submitSummary && (
				<SubmitResultCard
					success={props.submitSummary.success}
					className={classes.resultInfo}
					text={props.submitSummary.text}
				/>
			)}

			{actionsVisible && <Divider sx={{mt: 4}} />}

			{actionsVisible && (
				<Stack
					direction="row"
					sx={{
						justifyContent: props.actions ? "space-between" : "flex-end",
						mt: 3,
					}}
				>
					{props.actions}
					{submitVisible && (
						<ProgressButton
							variant="contained"
							disabled={props.submitDisabled}
							inProgress={props.submitting}
							onClick={props.onSubmit}
						>
							<Localized id="utils-button-submit">Submit</Localized>
						</ProgressButton>
					)}
				</Stack>
			)}
		</FormControl>
	);
};

export default SubmitableResponseArea;
